import { Grid } from "@mui/material";
import { CSSProperties } from "react";
import { FadeLoader, ClipLoader, ClockLoader, PulseLoader } from "react-spinners";

const override: CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: "-50px",
};

export function LoadingSpinner({
  spinnerType = "FadeLoader",
  loading,
  sx = null,
  ...props
}) {
  function renderSpinner() {
    switch (spinnerType) {
      case "ClipLoader":
        return (
          <ClipLoader
            loading={loading}
            cssOverride={override}
            aria-label="Loading Spinner"
            data-testid="loader"
            {...props}
          />
        );
      case "ClockLoader":
        return (
          <ClockLoader
            loading={loading}
            cssOverride={override}
            aria-label="Loading Spinner"
            data-testid="loader"
            {...props}
          />
        );
      case "PulseLoader":
        return (
          <PulseLoader
            loading={loading}
            cssOverride={override}
            aria-label="Loading Spinner"
            data-testid="loader"
            {...props}
          />
        );

      default:
        return (
          <FadeLoader
            loading={loading}
            cssOverride={override}
            aria-label="Loading Spinner"
            data-testid="loader"
            {...props}
          />
        );
    }
  }

  return (
    <Grid container justifyContent={"center"}>
      <Grid item>{renderSpinner()}</Grid>
    </Grid>
  );
}
